"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var typography_1 = require("../../shared/typography");
var types_1 = require("../../types");
var resolveBrandBodyFont_1 = require("../../utils/resolveBrandBodyFont");
var overrides_1 = require("../../shared/overrides");
var resolveBrandTypographyConfig_1 = require("../../utils/resolveBrandTypographyConfig");
var chips_1 = require("../../shared/chips");
var palette_1 = require("./palette");
Object.defineProperty(exports, "palette", { enumerable: true, get: function () { return palette_1.palette; } });
var typography_2 = require("./typography");
var buttons_1 = require("./buttons");
var alerts_1 = require("./alerts");
var cards_1 = require("./cards");
var chips_2 = require("./chips");
var badges_1 = require("./badges");
var overrides_2 = require("./overrides");
var fontFamily = (0, resolveBrandBodyFont_1.resolveBrandBodyFont)(types_1.TAGBrand.AspenDental);
var themeObj = {
    palette: palette_1.aspendentalPalette,
    typography: (0, resolveBrandTypographyConfig_1.resolveBrandTypographyConfig)(types_1.TAGBrand.AspenDental),
    components: __assign(__assign({ MuiTypography: {
            defaultProps: { variantMapping: typography_1.typographyVariantMapping },
            variants: typography_2.aspendentalTypography,
        }, MuiButtonBase: {
            defaultProps: {
                disableTouchRipple: true,
            },
        }, MuiButton: buttons_1.aspendentalButtons, MuiFab: {
            variants: buttons_1.aspendentalFloatingButtons,
        }, MuiPaper: { variants: cards_1.paperVariants }, MuiAlert: alerts_1.aspenDentalAlerts, MuiChip: {
            variants: __spreadArray(__spreadArray([], chips_2.chipVariants, true), badges_1.chipBadgeVariants, true),
            styleOverrides: __assign({}, chips_1.chipStyleOverride),
        }, MuiLink: {
            variants: [
                {
                    props: { variant: 'link' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            fontFamily: fontFamily,
                            fontWeight: 350,
                            fontSize: '1rem',
                            lineHeight: '1.25rem',
                            textAlign: 'center',
                            color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                            textDecorationColor: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                            cursor: 'pointer',
                        });
                    },
                },
            ],
        } }, (0, overrides_1.sharedOverrides)(types_1.TAGBrand.AspenDental)), overrides_2.overrides),
};
exports.default = themeObj;
